import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { AlertService } from 'ngx-alerts';
import { MatDialogRef } from '@angular/material/dialog';
import { CustomSnackbarService } from '@service/custom-snackbar.service';
import { ChatService } from '@service/chat.service'

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],

})
export class LoginComponent implements OnInit, OnDestroy {
  view: 'phone' | 'otp' | 'name' = 'phone';
  phone = '';
  otp = '';
  loginError = '';
  isSubmitting = false;
  isSubmittingOtp = false;
  otpError = '';

  readonly resendCooldownSeconds = 20;
  resendCooldown = 0;
  private resendTimer: any;

  name = '';
  nameError = '';
  isSubmittingName = false;

  constructor(public authService: AuthService,
    public alertService: AlertService, public dialogRef: MatDialogRef<LoginComponent>,
    private customSnackbarService: CustomSnackbarService,
    private chatService: ChatService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.clearResendTimer();
  }

  onPhoneInput(value: string) {
    this.phone = value.replace(/\D/g, '').slice(0, 10);
  }

  goBackToPhone() {
    this.view = 'phone';
    this.otp = '';
    this.otpError = '';
    this.clearResendTimer();
  }

  continuePhone() {
    if (!this.phone.trim() || this.isSubmitting) return;
    this.isSubmitting = true;
    this.loginError = '';
    this.authService.loginPhone(this.phone.trim()).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.otp = '';
        this.otpError = '';
        this.view = 'otp';
        this.startResendCooldown();
        this.cdr.detectChanges();
      },
      error: err => {
        this.isSubmitting = false;
        this.loginError = err.error || 'Failed to send OTP. Try again.';
        this.cdr.detectChanges();
      }
    });
  }

  resendOtp() {
    if (this.resendCooldown > 0 || this.isSubmitting) return;
    this.continuePhone();
  }

  private startResendCooldown() {
    this.clearResendTimer();
    this.resendCooldown = this.resendCooldownSeconds;
    this.resendTimer = setInterval(() => {
      this.resendCooldown--;
      if (this.resendCooldown <= 0) {
        this.clearResendTimer();
      }
      this.cdr.detectChanges();
    }, 1000);
  }

  private clearResendTimer() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
      this.resendTimer = null;
    }
    this.resendCooldown = 0;
  }

  submitOtp() {
    if (!this.otp.trim() || this.isSubmittingOtp) return;
    this.isSubmittingOtp = true;
    this.otpError = '';
    this.authService.verifyPhone(this.phone.trim(), this.otp.trim()).subscribe({
      next: (response: any) => {
        this.isSubmittingOtp = false;
        if (response?.requires_name) {
          this.view = 'name';
          this.cdr.detectChanges();
          return;
        }
        this.finishLogin();
      },
      error: err => {
        this.isSubmittingOtp = false;
        this.otpError = err.error || 'Invalid OTP. Please try again.';
        this.cdr.detectChanges();
      }
    });
  }

  submitName() {
    const trimmed = this.name.trim();
    if (!trimmed || this.isSubmittingName) return;
    this.isSubmittingName = true;
    this.nameError = '';
    this.authService.saveName(trimmed).subscribe({
      next: () => {
        this.isSubmittingName = false;
        this.finishLogin();
      },
      error: err => {
        this.isSubmittingName = false;
        this.nameError = err.error || 'Failed to save your name. Try again.';
        this.cdr.detectChanges();
      }
    });
  }

  private finishLogin() {
    this.dialogRef.close();
    this.customSnackbarService.open('Login Success', 'yeahh!!', 'white-snackbar');
    this.chatService.getConversations();
    // A pre-existing environment quirk keeps Angular's automatic change
    // detection from reliably picking up this state change in place (see
    // the note in auth.interceptor.ts). A reload is the one guaranteed way
    // for the header and rest of the page to actually reflect the new
    // logged-in session, so we take it here rather than leave login looking
    // broken.
    setTimeout(() => window.location.reload(), 600);
  }

}
